import {AuthApi} from "../utils/api"

export const getDateAsString = (date) => new Date(date).toLocaleDateString()

export const getSubmissionStatusAsString = (submission) => {
  if (!submission.submitId) {   // this is an isubmission
    if(submission.instantValidationResult && submission.instantValidationResult === "VALID")
    {
      return "Approved"
    }
    if (submission.statusId !== 0 || submission.statusId !== 3) {
      if (submission.instantValidationResult && submission.instantValidationResult === "INVALID")
      {
        return "Denied"
      }
      return "Pending"
    }
    return "Partial"
  }

  if (submission.offerErrors.length > 0 || (submission.instantValidationResult && submission.instantValidationResult === "INVALID")) {
    return "Denied"
  }

  if (submission.debitCard && submission.debitCard.issueStatus === 2) {
    return "Sent"
  }

  if (submission.valid === true || (submission.instantValidationResult && submission.instantValidationResult === "VALID")) {
    return "Approved"
  }

  return "Received"
}

export const parseClientFaq = (faq) => {
  const faqHeaders = [...new Set(faq.map(question => question.headerText))]
  const parsedFaq = []

  faqHeaders.forEach((header) => {
    const questionArray = faq
      .filter((question => question.headerText === header))
      .sort((a, b) => a.itemDisplayOrder - b.itemDisplayOrder)

    const question = {header: header, questions: questionArray }
    parsedFaq.push(question)
  })

  return parsedFaq
    .sort((q1, q2) => q1.questions[0].headerDisplayOrder - q2.questions[0].headerDisplayOrder)
}

export const createMarkup = (text) => {
  return {__html: text}
}

export const resetDispatch = async (state, dispatch) => {
  dispatch({type: "SETISUBMISSION", payload: ""})
  const removeAll = state.files.filter((file) => file.name === "")
  dispatch({type: "SETFILES", payload: removeAll})
  dispatch({type: "SETCAMPAIGN", payload: ""})
  dispatch({type: "SETSELECTEDPHONE", payload: ""})
  dispatch({type: "SETSUBMITTED", payload: false})
  dispatch({type: "SETCHOSEMAILIN", payload: false})
}

export const validateImei = (imei) => {
  const imeiArray = imei.split("")

  const validationArray = imeiArray.map((digit, index) => {
    let parsedDigit = parseInt(digit, 10)

    if (index % 2 !== 0) {
      parsedDigit = parsedDigit * 2
    }

    if (parsedDigit > 9) {
      parsedDigit = ((parsedDigit % 10) + (parsedDigit / parsedDigit))
    }

    return parsedDigit
  })

  const validationTotal = validationArray.reduce( (accumulator, currentValue) => accumulator + currentValue)

  return validationTotal % 10 === 0
}

export const getTmoAuthUrl = (promoCode) => {
  if (promoCode) {
    return process.env.REACT_APP_TMO_ID_AUTH_URL.replace("=TMobileAuthCallback", `=PromoCode:${promoCode}`)
  } else {
    return process.env.REACT_APP_TMO_ID_AUTH_URL
  }
}

export const validatePhone = (value) => {
  let error
  const validPhoneLengthRegEx = /(^$)|(^\d{10}$)/
  if (!value) {
    error = "Phone Number is required"
  }

  if (value && !value.replace(/[^a-z0-9]/g, "").match(validPhoneLengthRegEx)) {
    error = "Phone Number must be 10 digits"
  }

  if (value && (value.charAt(0) === '1' || value.charAt(0) === '0')) {
    error = "Phone Number cannot start with 0 or 1"
  }

  return error
}

export const isNotNullOrWhiteSpace = (str) => str && str.trim()

export const isOnPage = (page) => {
  if(window.location.pathname && window.location.pathname.length){
    const path = window.location.pathname.toLowerCase()
    if(path.includes(page)){
      return true
    }
  }

  return false
}

export const setDnsSetting = async (dnsObject, tMobileId) => {
  if(navigator.globalPrivacyControl ){
    if(dnsObject.globalDoNotSellSetting === 'Sell'){
      await AuthApi.setGlobalDnsSetting(tMobileId, 1)
    }
    else if(dnsObject.globalDoNotSellSetting === 'DoNotSell' && dnsObject.globalDoNotSellSettingDate == null){
      await AuthApi.setGlobalDnsSetting(tMobileId, 1)
    }
  }
}

